import React from 'react'
import LogoProssed from '@resources/imgs/logo-proseed.webp'
import LogoEuropean from '@resources/imgs/european.webp'
import LogoSeattle from '@resources/imgs/seattle.png'

interface DonorBankLogoProps {
  bankName?: string
}

const DonorBankLogo: React.FC<DonorBankLogoProps> = ({ bankName }) => {
  const renderLogo = () => {
    if (bankName === 'Pro-Seed') return <img src={LogoProssed} alt="Pro-Seed" />
    if (bankName === 'European Sperm Bank') return <img src={LogoEuropean} alt="European Sperm Bank" />
    if (bankName === 'Seattle Sperm Bank') return <img src={LogoSeattle} alt="Seattle Sperm Bank" />
    return <img src={LogoProssed} alt="Banco de sêmen" />
  }

  return (
    <div className="donor-card__bank-section" aria-hidden={!bankName}>
      {renderLogo()}
    </div>
  )
}

export default DonorBankLogo
